<template>
  <div class="navbarcontainer">
    <div class="stagingHeader" v-if="stagingHeader">
      <h4>{{ stagingHeader }}</h4>
    </div>
    <div class="navbar" :class="{ 'no-padding': noPadding }">
      <div class="navbar-left">
        <font-awesome-icon
          v-if="$route.name === 'transactionDetail'"
          icon="chevron-left"
          class="icon"
          v-on:click="$router.push({ name: $namedRoutes.transactionOverview })"
        />
        <font-awesome-icon v-else-if="back" icon="chevron-left" class="icon" v-on:click="$router.go(-1)" />
        <router-link
          v-if="location"
          :to="{ name: $namedRoutes.locationOptions, params: { communeId: $route.params.communeId } }"
        >
          <font-awesome-icon icon="map-marker-alt" class="icon" />
        </router-link>
        <font-awesome-icon v-if="favorites" icon="bookmark" class="icon" v-on:click="goFavorites" />
      </div>
      <div class="navbar-center" :class="{ 'with-commune': commune }">
        <NewTranslation
          v-if="titleTranslationPath"
          :path="titleTranslationPath"
          :params="params"
          v-on:click="onCommuneClick"
        />
        <span v-else-if="title">{{ title }}</span>
        <span
          v-if="commune"
          class="selected-commune"
          v-on:click="
            () => {
              if (commune)
                $router.push({ name: $namedRoutes.locationOptions, params: { communeId: $route.params.communeId } });
            }
          "
          >({{ communeInfo.name }})</span
        >
      </div>
      <div class="navbar-right">
        <LanguageSelector :lang="locale" />
        <font-awesome-icon
          icon="lock-open"
          v-if="loginStatus && !loggedInUser"
          v-on:click="$router.push({ name: $namedRoutes.login })"
          class="icon"
        />
        <font-awesome-icon icon="lock" v-if="loginStatus && !!loggedInUser" v-on:click="logout" class="icon" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import NewTranslation from '@/components/i18n/NewTranslation';
import LanguageSelector from '@/components/LanguageSelector';
import AuthApi from '@/app/api/AuthApi';

export default {
  components: {
    LanguageSelector,
    NewTranslation,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    back: {
      type: Boolean,
    },
    titleTranslationPath: {
      type: String,
    },
    params: {
      type: Object,
    },
    location: {
      type: Boolean,
    },
    search: {
      type: Boolean,
    },
    favorites: {
      type: Boolean,
    },
    preferences: {
      type: Boolean,
    },
    commune: {
      type: Boolean,
    },
    loginStatus: {
      type: Boolean,
      default: true,
    },
    flag: {
      type: Boolean,
      default: true,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goFavorites() {
      this.$router.push({
        name: this.$namedRoutes.benefitsCategory,
        query: {
          categoryName: 'favorites',
        },
      });
    },
    goPreferences() {
      this.$router.push({
        name: this.$namedRoutes.benefitsCategory,
        query: {
          categoryName: 'preferences',
        },
      });
    },
    logout() {
      this.$store.commit('openOverlay', 'LogOut');
    },
    onCommuneClick() {
      if (this.commune)
        this.$router.push({ name: this.$namedRoutes.locationOptions, params: { communeId: $route.params.communeId } });
    },
  },
  computed: {
    ...mapGetters([
      'currentPageCategory',
      'currentPageData',
      'benefitCategories',
      'loggedInUser',
      'settedLang',
      'communeInfo',
    ]),
    ...mapGetters('i18n', ['locale']),

    stagingHeader() {
      const release = process.env.HELM_RELEASE;
      if (!release) {
        return 'UNBEKANNT';
      }

      return release.includes('production') ? null : release.includes('staging') ? 'STAGING' : 'TEST';
    },
  },
};
</script>

<style lang="sass" scoped>
.selected-commune
    display: block
    font-size: .8rem

.navbarcontainer
  width: 100%

.navbar
    padding: 20px
    display: flex
    width: 100%
    justify-content: space-between

    &-left,
    &-right
        flex-basis: 17%
        display: flex
        justify-content: space-between

    &-center
        text-align: center

    .with-commune
        margin-top: -7px
        margin-bottom: -7px

    .search
        & + .favorites
            margin-left: 10px

    .flag + .search
        margin-left: 10px

    .location + .search
        margin-left: 10px

    .flag + .signIn
        margin-left: 10px

    .flag + .signOut
        margin-left: 10px

    .flag + .preferences
        margin-left: 10px

    .favorites + .signIn
        margin-left: 10px

    .favorites + .signOut
        margin-left: 10px

    .preferences + .signIn
        margin-left: 10px

    .preferences + .signOut
        margin-left: 10px

    .favorites
        margin-left: auto

        & + .preferences
            margin-left: 10px

.icon
    display: block
    width: 20px
    height: 20px
    object-fit: contain
    object-position: center center
    border: none !important

.no-padding
    padding-left: 0
    padding-right: 0

.stagingHeader
    width: 100%
    background-color: red
    padding: 2px
    color: white
    text-align: center
    h4
      padding: 0
      margin: 0
      font-size: 12px
      font-weight: bold
</style>
